/* eslint-disable prettier/prettier */
import * as React from "react";
import {
  Grid,
  Link,
  Modal,
  TextField,
  MenuItem,
  Snackbar,
  Alert,
  Typography,
} from "@mui/material";

// helpers
import { getHeaders } from "../../utils/HeaderHelper";
import GeneralModal from "../../modals/GeneralModal";

interface Props {
  csrfToken: string;
  selectedProvider: any;
  menu_track_src: string;
  getCustomerUsers: any;
  associationModalOpen: boolean;
  setAssociationModalOpen: any;
}

const CoreTeamCustomerAssociationModalNew: React.FC<Props> = (props: any) => {
  const [customerOptions, setCustomerOptions] = React.useState<any>(null);
  const [selectedCustomerID, setselectedCustomerID] = React.useState<any>(null);
  const [error, setError] = React.useState<string>("");

  const handleCustomerUserSave = () => {
    event.preventDefault();

    if (!selectedCustomerID) {
      setError("Please select an organization");
      return;
    }

    fetch(`/provider_customer_users`, {
      method: "POST",
      headers: getHeaders(props.csrfToken),
      body: JSON.stringify({
        customer_user: {
          user_id: props.selectedProvider.user_id,
          customer_id: selectedCustomerID,
        },
      }),
    })
      .then((result) => result.json())
      .then((result) => {
        if (result.success == false) {
          setError(result.message);
        } else {
          props.setAssociationModalOpen(false);
          props.getCustomerUsers();
          setError("");
        }
      })
      .catch((error) => {
        console.log(error);
        setError("Failed to create association. Please try again.");
      });
  };

  React.useEffect(() => {
    if (!props.associationModalOpen || !props.selectedProvider?.user_id) {
      if (!props.associationModalOpen) {
        setCustomerOptions(null);
        setselectedCustomerID(null);
        setError("");
      }
      return;
    }

    if (props.selectedProvider?.starfield_admin) {
      setCustomerOptions([]);
      setselectedCustomerID(null);
      return;
    }

    fetch(`/provider_customer_users/new?user_id=${props.selectedProvider.user_id}`, {
      method: "GET",
      headers: getHeaders(props.csrfToken),
    })
      .then((result) => result.json())
      .then((result) => {
        if (typeof result.error !== "undefined") {
          console.log(result.error);
        } else {
          if (result?.data?.blocked) {
            setError(
              result?.data?.message ||
                "Cannot add explicit associations for this user."
            );
            setCustomerOptions([]);
            return;
          }

          setCustomerOptions(result?.data?.customers || []);
          if (result?.data?.customers && result.data.customers.length > 0) {
            setselectedCustomerID(result.data.customers[0].id);
          } else {
            setselectedCustomerID(null);
          }
        }
      })
      .catch((error) => {
        console.log(error);
        setError("Failed to load organizations. Please try again.");
      });
  }, [props.selectedProvider, props.associationModalOpen, props.csrfToken]);

  return (
    <>
      
      <GeneralModal
        open={props.associationModalOpen}
        title={"Add Association"}
        successCallback={handleCustomerUserSave}
        closeCallback={() => {
          props.setAssociationModalOpen(false);
          setError("");
        }}
        confirmButtonDisabled={
          !selectedCustomerID || customerOptions?.length === 0
        }
        containerClassName="add-patient-modal"
        confirmButtonText="Confirm"
        width="600px"
      >
        <Grid container style={{ paddingTop: 20 }}>
          <Grid item xs={12}>
            {customerOptions && customerOptions.length > 0 ? (
              <TextField
                id="customer_id"
                size="small"
                className="textInput"
                value={selectedCustomerID || ""}
                variant="outlined"
                onChange={(event) => {
                  setselectedCustomerID(event.target.value);
                }}
                select
                fullWidth
                label="Organization"
              >
                {customerOptions.map((customer, index) => (
                  <MenuItem key={index} value={customer.id}>
                    {customer.name}
                  </MenuItem>
                ))}
              </TextField>
            ) : customerOptions?.length === 0 ? (
              <Typography
                variant="body2"
                color="textSecondary"
                sx={{ padding: 2 }}
              >
                No organizations available. This user may already have explicit
                associations with all available organizations, or you may not
                have permission to add associations for this user.
              </Typography>
            ) : null}
          </Grid>
        </Grid>
      </GeneralModal>
    </>
  );
};

export default CoreTeamCustomerAssociationModalNew;
